// Function to generate consistent colors based on text
export const generateColorFromText = (
  text: string
): { color: string; background: string } => {
  // Create a simple hash from the name
  let hash = 0;
  for (let i = 0; i < text.length; i++) {
    const char = text.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32-bit integer
  }

  // Use absolute value to ensure positive number
  hash = Math.abs(hash);

  // Generate RGB color values
  const red = (hash >> 16) & 255; // Extract red component
  const green = (hash >> 8) & 255; // Extract green component
  const blue = hash & 255; // Extract blue component

  // Ensure colors are not too dark or too light for good contrast
  const adjustedRed = Math.max(50, Math.min(200, red));
  const adjustedGreen = Math.max(50, Math.min(200, green));
  const adjustedBlue = Math.max(50, Math.min(200, blue));

  // Convert to hex
  const toHex = (value: number) => value.toString(16).padStart(2, "0");

  const backgroundColor = `#${toHex(adjustedRed)}${toHex(adjustedGreen)}${toHex(adjustedBlue)}`;

  // Calculate luminance to determine if we should use white or black text
  const luminance =
    (0.299 * adjustedRed + 0.587 * adjustedGreen + 0.114 * adjustedBlue) / 255;
  const textColor = luminance > 0.5 ? "black" : "white";

  return { color: textColor, background: backgroundColor };
};
